export const buildOptimisticCommentUpsertPayload = ({
  author,
  permlink,
  body,
  jsonMetadata,
  targetPost,
  createdAt,
  voteCount = 0,
  replyCount = 0
}) => ({
  author,
  permlink,
  body,
  json_metadata: jsonMetadata,
  parent_author: targetPost?.author,
  parent_permlink: targetPost?.permlink,
  created_at: createdAt || new Date().toISOString(),
  vote_count: voteCount,
  reply_count: replyCount
});

export const buildOptimisticComment = ({
  author,
  permlink,
  body,
  createdAt,
  jsonMetadata,
  targetPost,
  rootAuthor,
  depth = 1
}) => ({
  author,
  permlink,
  body,
  created: createdAt,
  json_metadata: jsonMetadata,
  parentAuthor: targetPost?.author,
  parentPermlink: targetPost?.permlink,
  rootAuthor,
  replies: [],
  depth,
  optimistic: true,
  optimisticStatus: 'pending',
  optimisticType: 'comment'
});
